export function addItemToCsvList (item, list) {
    if(!list) return item
    //transform list into array
    let array = list ? list.split(',') : []
    //already contains, return
    if (list.includes(item)) return list
    //add new item
    array.push(item)
    //return string version of array in alphabetical order
    return array.sort().toString().trim()
}

export function removeItemFromCsvList (item, list) {
    //transform list into array
    let array = list ? list.split(',') : []
    //remove item
    array.splice(array.indexOf(item), 1)
    //return array with item removed
    return array.toString().trim()
}

export function csvToArray (csv) {
    return csv ? csv.split(',') : []
}
